module.exports = __webpack_public_path__ + "img/124.6.1f9bc737.png";